import React from "react";
import DataProfilePrimaryTab from '../../shared/DataProfilePrimaryTab';
import { PrimaryLayout } from '../Layout';

// Primary tab of the WM Rate Schedule Profile form (Delphi uWMD0005): the profile block and the User
// Defined Codes block, rendered by the shared DataProfilePrimaryTab.
const PrimaryTab = (props) => (
    <DataProfilePrimaryTab
        {...props}
        layoutId="8FE3D63B-3D83-4B5D-9A1F-59FEBEAE715A"
        layoutName="WMRateScheduleProfilePrimaryForm"
        defaultFormSchema={PrimaryLayout}
    />
);

export default PrimaryTab;
